<template>
  <div class="card-body"
       :class="[bodyClasses]"
       :style="{
                'padding': bodyPadding,
                'overflow-y': scrollY ? 'scroll' : 'hidden',
                'overflow-x': scrollX ? 'scroll' : 'hidden'
            }">
    <slot></slot>
  </div>
</template>

<script>
import checkPermissions from '../../../mixins/checkPermissions';

export default {
  name: "ks-card-body",
  mixins: [checkPermissions],
  computed: {
    screenSizeId() {
      return app.layout.screenSizeId;
    },
    data_provider_ref() {
      return this.$parent.data_provider_ref ? this.$parent.data_provider_ref : {};
    },
    dataProvider() {
      return this.$parent.dataProvider ? this.$parent.dataProvider : null;
    },
    type() {
      return this.$parent.type ? this.$parent.type : null;
    }
  },
  props: {
    bodyClasses:  {type: String,    default: ''},
    scrollY:      {type: Boolean,   default: true},
    scrollX:      {type: Boolean, default: true},
    bodyPadding:  {type: String,    default: '10px'}
  },
  data() {
    return {
      multiCampaign: null
    }
  }
}
</script>
